export default "__VITE_ASSET__27zTq4kq__"